import InventoryDashboard from "@/components/inventory/ingredients/InventoryDashboard";
import { useAppSelector } from "@/redux/features/hooks";

const IngredientsPage = () => {
  const restaurant = useAppSelector((state) => state.user.currentRestaurant);

  if (!restaurant) return null;

  return <InventoryDashboard restaurantId={restaurant.id} />;
};

export default IngredientsPage;
